import * as React from "react"

const buttonVariants = (variant = 'default', size = 'default', className = '') => {
  const baseClasses = "inline-flex items-center justify-center rounded-lg text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed ring-offset-background active:scale-[0.98]";
  
  const variants = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-[1.02] shadow-md hover:shadow-lg",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:scale-[1.02] shadow-md hover:shadow-lg",
    outline: "border-2 border-border bg-background hover:bg-accent/5 hover:border-accent/50",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:scale-[1.02]",
    ghost: "hover:bg-accent/10 hover:text-accent",
    link: "text-primary underline-offset-4 hover:underline hover:text-primary/80"
  };

  const sizes = {
    default: "h-10 py-2 px-4",
    sm: "h-9 px-3 rounded-md text-xs",
    lg: "h-12 px-8 rounded-lg text-base",
    icon: "h-10 w-10"
  };

  return [
    baseClasses,
    variants[variant] || variants.default,
    sizes[size] || sizes.default,
    className
  ].filter(Boolean).join(' ');
};

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? 'div' : 'button';
  const buttonClasses = buttonVariants(variant, size, className);
  
  return (
    <Comp
      className={buttonClasses}
      ref={ref}
      {...props}
    />
  );
});

Button.displayName = "Button";

export { Button, buttonVariants };
